module.exports = __webpack_public_path__ + "img/lamp-floor.df4f4437.svg";